import { Component, ElementRef, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputComponent),
            multi: true
        }
    ],
    standalone: false
})
export class InputComponent implements ControlValueAccessor {
    private _disabled: boolean;
    @Input()
    set disabled(disabled: boolean | '') {
        this._disabled = disabled === '' || disabled;
    }
    get disabled(): boolean | '' {
        return this._disabled;
    }

    private _readonly: boolean;
    @Input()
    set readonly(readonly: boolean | '') {
        this._readonly = readonly === '' || readonly;
    }
    get readonly(): boolean | '' {
        return this._readonly;
    }

    @Input() icon = '';
    @Input() maxLength = '524288';
    @Input() placeholder = '';
    @Input() tabindex = '0';
    @Input() type: 'password' | 'text' | 'email' | 'tel' = 'text';
    @Input() value = '';

    @ViewChild('inputElement') inputElement: ElementRef;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onChange = (_: any): void => { };
    onTouch = (): void => { };

    handleChange(event: any): void {
        this.onChange(event.target?.value);
    }

    handleInput(event: Event): void {
        this.onTouch();
        this.onChange(this.value);
    }

    getFocus(): void {
        if (this.inputElement) {
            this.inputElement.nativeElement.focus();
        }
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    writeValue(value: any): void {
        if (value) {
            this.value = value || '';
        } else {
            this.value = '';
        }
    }
}
